/// <reference path='../../interfaces/interfaces.d.ts' />

import { throws } from "assert";

'use strict';


class EmployeeImportController {
    public static $inject = [
        '$scope',
        '$state',
        'upload',
        '$http',
        'Employee',
        'User',
        'toaster',
        'bsLoadingOverlayService',
        '$uibModal',
    ];

    public employees;
    public user;
    public hasPermission;
    public importVisible = false;
    public fileInfo: any = {};
    public isFileValid = true;
    public currentStep = 1;
    public responseData;
    public columns_req: any[];
    public columns: any[];
    public columns_select: any[] = [];
    public isValid = false;
    public columns_dt = ['DD/MM/YYYY', "YYYY/MM/DD", "MM/DD/YYYY"];
    public success = false;
    public colTypes = ['employment_start_date','first_name', 'last_name', 'email', 'nationality', 'birth_date', 'job_title',  
        'gender', 'marital_status', 'religion', 'languages', 'home_address', 'phone_number', 'work_address',
        'work_phone_number', 'work_mobile_number', 'emergency_name', 'emergency_address', 'emergency_phone_number',
        'emergency_relation', 'start_date', 'user_role', 'bank_name', 'bank_address', 'routing_code', 'account_number',
        'iban_number', 'account_name', 'contract_type', 'contract_start_date', 'passport_number', 'passport_expiry',
        'visa_number', 'visa_expiry', 'emirates_id_number', 'emirates_id_expiry_date', 'labour_card_number', 'labour_card_expiry_date',
        'monthly_salary', 'paid_leave_per_year', 'paid_leave_carried_forward', 'sick_leave_per_year', 'maternity_leave', 'paternity_leave'];

    public col_models = [-1, -1, -1, -1, -1, -1, -1, -1];
    public col_models_dt = ['DD/MM/YYYY', 'DD/MM/YYYY', 'DD/MM/YYYY', 'DD/MM/YYYY', 'DD/MM/YYYY', 'DD/MM/YYYY', 'DD/MM/YYYY'];
    public nationalities = ["", "Afghan", "Albanian", "Algerian", "American", "Andorran", "Angolan", "Antiguans", "Argentinean", "Armenian", "Australian", "Austrian", "Azerbaijani", "Bahamian", "Bahraini", "Bangladeshi", "Barbadian", "Barbudans", "Batswana", "Belarusian", "Belgian", "Belizean", "Beninese", "Bhutanese", "Bolivian", "Bosnian", "Brazilian", "British", "Bruneian", "Bulgarian", "Burkinabe", "Burmese", "Burundian", "Cambodian", "Cameroonian", "Canadian", "Cape Verdean", "Central African", "Chadian", "Chilean", "Chinese", "Colombian", "Comoran", "Congolese", "Costa Rican", "Croatian", "Cuban", "Cypriot", "Czech", "Danish", "Djibouti", "Dominican", "Dutch", "East Timorese", "Ecuadorean", "Egyptian", "Emirati", "Emirian", "Equatorial Guinean", "Eritrean", "Estonian", "Ethiopian", "Fijian", "Filipino", "Finnish", "French", "Gabonese", "Gambian", "Georgian", "German", "Ghanaian", "Greek", "Grenadian", "Guatemalan", "Guinea-Bissauan", "Guinean", "Guyanese", "Haitian", "Herzegovinian", "Honduran", "Hungarian", "I-Kiribati", "Icelander", "Indian", "Indonesian", "Iranian", "Iraqi", "Irish", "Israeli", "Italian", "Ivorian", "Jamaican", "Japanese", "Jordanian", "Kazakhstani", "Kenyan", "Kittian and Nevisian", "Kuwaiti", "Kyrgyz", "Laotian", "Latvian", "Lebanese", "Liberian", "Libyan", "Liechtensteiner", "Lithuanian", "Luxembourger", "Macedonian", "Malagasy", "Malawian", "Malaysian", "Maldivan", "Malian", "Maltese", "Marshallese", "Mauritanian", "Mauritian", "Mexican", "Micronesian", "Moldovan", "Monacan", "Mongolian", "Moroccan", "Mosotho", "Motswana", "Mozambican", "Namibian", "Nauruan", "Nepalese", "New Zealander", "Nicaraguan", "Nigerian", "Nigerien", "North Korean", "Northern Irish", "Norwegian", "Omani", "Pakistani", "Palauan", "Palestinian", "Panamanian", "Papua New Guinean", "Paraguayan", "Peruvian", "Polish", "Portuguese", "Qatari", "Romanian", "Russian", "Rwandan", "Saint Lucian", "Salvadoran", "Samoan", "San Marinese", "Sao Tomean", "Saudi", "Scottish", "Senegalese", "Serbian", "Seychellois", "Sierra Leonean", "Singaporean", "Slovakian", "Slovenian", "Solomon Islander", "Somali", "South African", "South Korean", "Spanish", "Srilankan", "Sudanese", "Surinamer", "Swazi", "Swedish", "Swiss", "Syrian", "Taiwanese", "Tajik", "Tanzanian", "Thai", "Togolese", "Tongan", "Trinidadian or Tobagonian", "Tunisian", "Turkish", "Tuvaluan", "Ugandan", "Ukrainian", "Uruguayan", "Uzbekistani", "Venezuelan", "Vietnamese", "Welsh", "Yemenite", "Zambian", "Zimbabwean"];
    public new_value;
    public prev_value;
    public done;
    public numEmployees = 0;
    public massInvite: boolean = false;
    public newEmailAddresses = {};

    constructor(private $scope: any,
        private $state: ng.ui.IStateService,
        private upload: any,
        private $http: any,
        private Employee: IEmpService,
        private User: IUserService,
        private toaster: any,
        private bsLoadingOverlayService: IBsLoadingService,
        private $uibModal: any,) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        this.user = User;
        this.hasPermission = User.hasPermission;
        this.fileInfo = {};
        this.$scope.getField = this.getField;
    }

    public updateFileData(file_data: any) {
        this.fileInfo.file = file_data;
    }

    public fileChange() {
        this.importVisible = false
    }

    public isValidDate(dateString) {
        var regEx = /^\d{4}-\d{2}-\d{2}$/;
        return dateString.match(regEx) != null;
    }

    public isNullOrEmptyOrUndefined(value) {
        return !value;
    }

    public isStepCompleted(step) {
        return step <= this.currentStep
    }

    public doIt() {
        this.currentStep++;
    }

    public doBack() {
        if (this.currentStep === 2 || this.currentStep === 3) {
            this.fileInfo.file = undefined;
        }
        if (this.currentStep > 1) {
            this.currentStep--;
        }


    }

    private getColByType(colType) {
        var cols = this.responseData['cols'];

        // Find column definition
        for (var i in cols) {
            if (cols[i]['type'] == colType) {
                return cols[i];
            }
        }
        return null;
    }

    public getField(row, colType): any {
        if (!this.responseData) {
            return '';
        }

        var currentCol = this.getColByType(colType);


        if (!currentCol || currentCol['skip']) {
            return null;
        }
        var fileColIdx = currentCol['file_col_index'];

        // Get the file field, if there is one
        if (fileColIdx + 1 <= row['fields'].length) {
            var field = row['fields'][fileColIdx];
            return [currentCol, field];
        } else {
            return null;
        }
    }

    public getFieldValue(row, colType): string {
        let ret = this.getField(row, colType);
        if (ret) {
            let field = ret[1];
            // Update field value if date
            return field['output_value'];
        } else {
            return '';
        }
    }

    private validateField(col, field, colType) {
        let value = field['output_value'];

        if (field['has_error']) return [true, field['error']];
        if (col['required'] && value == '') return [true, 'Field is required',];

        // Check for valid email address
        if (colType == 'email') {
            let idx_at = value.indexOf('@');
            if (idx_at == -1) return [true, 'Not a valid email address',];
            if (value.indexOf('.', idx_at) == -1) return [true, 'Not a valid email address',];

            if (value in this.newEmailAddresses) {
                let inRows = this.newEmailAddresses[value];
                if (inRows.length > 1) {
                    return [true, 'Email address used for more than one employee',];
                }
            }
        }

        // Check for valid date value
        if (colType == 'birth_date' ||
            colType == 'contract_start_date' ||
            colType == 'employment_start_date' ||
            colType == 'passport_expiry' ||
            colType == 'visa_expiry' ||
            colType == 'emirates_id_expiry_date' ||
            colType == 'labour_card_expiry_date') {
            if (value == '') return [false, 'Valid'];

            let date_format = col['date_fmt'];
            let date_formats = [date_format];
            if (date_format == 'MM/DD/YYYY') {
                date_formats.push('MM/D/YYYY');
                date_formats.push('M/DD/YYYY');
                date_formats.push('M/D/YYYY');

                date_formats.push('MM-DD-YYYY');
                date_formats.push('MM-D-YYYY');
                date_formats.push('M-DD-YYYY');
                date_formats.push('M-D-YYYY');

                date_formats.push('MM.DD.YYYY');
                date_formats.push('MM.D.YYYY');
                date_formats.push('M.DD.YYYY');
                date_formats.push('M.D.YYYY');
            }
            else if (date_format == 'DD/MM/YYYY') {
                date_formats.push('DD/M/YYYY');
                date_formats.push('D/MM/YYYY');
                date_formats.push('D/M/YYYY');

                date_formats.push('DD-MM-YYYY');
                date_formats.push('DD-M-YYYY');
                date_formats.push('D-MM-YYYY');
                date_formats.push('D-M-YYYY');

                date_formats.push('DD.MM.YYYY');
                date_formats.push('DD.M.YYYY');
                date_formats.push('D.MM.YYYY');
                date_formats.push('D.M.YYYY');
            }
            else if (date_format == 'YYYY/MM/DD') {
                date_formats.push('YYYY/MM/D');
                date_formats.push('YYYY/M/DD');
                date_formats.push('YYYY/M/D');

                date_formats.push('YYYY-MM-DD');
                date_formats.push('YYYY-MM-D');
                date_formats.push('YYYY-M-DD');
                date_formats.push('YYYY-M-D');

                date_formats.push('YYYY.MM.DD');
                date_formats.push('YYYY.MM.D');
                date_formats.push('YYYY.M.DD');
                date_formats.push('YYYY.M.D');
            }


            let m_date = moment(value, date_formats, true);
            if (!m_date.isValid()) return [true, "Date not in correct format: " + date_format];
        }

        // Check for valid nationality
        if (colType == 'nationality') {
            if (value !== "" && this.nationalities.indexOf(value) == -1) {
                return [true, "Not a valid nationality"];
            }
        }


        // Default value - success
        return [false, 'Valid'];
    }

    private checkFieldForError(row, colType: string): boolean {
        let ret = this.getField(row, colType);
        if (ret) {
            let col = ret[0];
            let field = ret[1];
            let error = this.validateField(col, field, colType);

            return error[0];
        } else {
            return false;
        }

    }

    public getFieldHasError(row, colType?: string): boolean {
        if (!row['import']) return false;

        if (colType) {
            return this.checkFieldForError(row, colType)
        }

        // Check each field for an error
        return this.colTypes.some((columnType) => {
            return this.checkFieldForError(row, columnType);
        });
    }

    public getFieldError(row, colType): string {
        if (!row['import']) return '';
        var ret = this.getField(row, colType);
        if (ret) {
            var col = ret[0];
            var field = ret[1];
            let error = this.validateField(col, field, colType);

            return error[1];
        } else {
            return '';
        }

    }

    public changeColumnSelect(colIndex, colType) {
        let new_f_col_idx = this.col_models[colIndex];
        var currentCol = this.getColByType(colType);
        currentCol['file_col_index'] = new_f_col_idx;
    }

    public changeColumnSelectDt(colIndex, colType) {
        var currentCol = this.getColByType(colType);
        currentCol['date_fmt'] = this.col_models_dt[colIndex]
    }

    public doImport() {
        let newEmps = [];

        for (let ri in this.employees) {
            let row = this.employees[ri];
            if (!row['import']) continue;

            let newEmp = {};
            if (row['invite']) {
                newEmp['invite'] = true;
            } else {
                newEmp['invite'] = false;
            }


            for (let ci in this.colTypes) {
                let colType = this.colTypes[ci];
                let ret = this.getField(row, colType);
                let col = this.getColByType(colType);
                let val = '';
                // If column is not skipped
                if (ret) {
                    let field = ret[1];

                    // Check for valid date value
                    if ((colType == 'birth_date' ||
                        colType == 'contract_start_date' ||
                        colType == 'employment_start_date' ||
                        colType == 'passport_expiry' ||
                        colType == 'visa_expiry' ||
                        colType == 'emirates_id_expiry_date' ||
                        colType == 'labour_card_expiry_date') && field['output_value'] != '') {

                        let date_format = col['date_fmt'];
                        let date_formats = [date_format];
                        if (date_format == 'MM/DD/YYYY') {
                            date_formats.push('MM/D/YYYY');
                            date_formats.push('M/DD/YYYY');
                            date_formats.push('M/D/YYYY');

                            date_formats.push('MM-DD-YYYY');
                            date_formats.push('MM-D-YYYY');
                            date_formats.push('M-DD-YYYY');
                            date_formats.push('M-D-YYYY');

                            date_formats.push('MM.DD.YYYY');
                            date_formats.push('MM.D.YYYY');
                            date_formats.push('M.DD.YYYY');
                            date_formats.push('M.D.YYYY');
                        }
                        else if (date_format == 'DD/MM/YYYY') {
                            date_formats.push('DD/M/YYYY');
                            date_formats.push('D/MM/YYYY');
                            date_formats.push('D/M/YYYY');

                            date_formats.push('DD-MM-YYYY');
                            date_formats.push('DD-M-YYYY');
                            date_formats.push('D-MM-YYYY');
                            date_formats.push('D-M-YYYY');

                            date_formats.push('DD.MM.YYYY');
                            date_formats.push('DD.M.YYYY');
                            date_formats.push('D.MM.YYYY');
                            date_formats.push('D.M.YYYY');
                        }
                        else if (date_format == 'YYYY/MM/DD') {
                            date_formats.push('YYYY/MM/D');
                            date_formats.push('YYYY/M/DD');
                            date_formats.push('YYYY/M/D');

                            date_formats.push('YYYY-MM-DD');
                            date_formats.push('YYYY-MM-D');
                            date_formats.push('YYYY-M-DD');
                            date_formats.push('YYYY-M-D');

                            date_formats.push('YYYY.MM.DD');
                            date_formats.push('YYYY.MM.D');
                            date_formats.push('YYYY.M.DD');
                            date_formats.push('YYYY.M.D');
                        }

                        let m_date = moment(field['output_value'], date_formats, true);
                        val = m_date.format('YYYY-MM-DD');
                    } else {
                        val = field['output_value'];
                    }

                }
                newEmp[colType] = val;

            }
            newEmps.push(newEmp);
        }

        this.currentStep++;

        // Upload actual data
        this.bsLoadingOverlayService.start({ referenceId: 'emplist_loader' });
        this.$http.post('/api/employees/import_upload_final', newEmps).then((response) => {
            this.bsLoadingOverlayService.stop({ referenceId: 'emplist_loader' });
            this.emitEvent('employee.import.upload_import');
            this.toaster.pop('success', 'upload complete', '');
            this.done = true;
            this.success = true;
        },
            (response) => {
                this.done = true;
                this.bsLoadingOverlayService.stop({ referenceId: 'emplist_loader' });
                this.emitEvent('employee.import.upload_import.error');
                if (response.status == 400) {
                    this.toaster.pop('error', 'Import Failed', response.data);
                } else {
                    this.toaster.pop('error', 'Error', response.data);
                }
            }
        );


    }

    public doValidation() {
        this.isValid = true;
        let empCount = 0;

        // Count number of employees that will be imported
        for (let ri in this.employees) {
            let row = this.employees[ri];
            if (!row['import']) continue;
            empCount++;
        }

        this.numEmployees = empCount;

        // Validate all fields, until error is found
        for (let ri in this.employees) {
            let row = this.employees[ri];
            if (!row['import']) continue;
            for (let ci in this.colTypes) {
                let colType = this.colTypes[ci];
                if (this.getFieldHasError(row, colType)) {
                    this.isValid = false;
                    return this.isValid;
                }
            }
        }
        return this.isValid;
    }

    public editCell(row, colType: string): string {
        let ret = this.getField(row, colType);
        if (ret) {
            let field = ret[1];
            this.prev_value = field['output_value'];
            this.edit_modal(field, colType);
            // Update field value if date
            return field['output_value'];
        } else {
            return '';
        }
    }

    public doUpload(preview = true) {
        if (this.fileInfo['file'] === undefined) {
            return
        }


        this.bsLoadingOverlayService.start({ referenceId: 'emplist_loader' });
     
        this.upload({
            url: '/api/employees/import_upload',
            // url: '/api/employees/csv_' + (preview ? 'preview' : 'upload'),
            method: 'POST',
            data: { file: this.fileInfo.file }
        }).then(
            (response) => {
          
                this.emitEvent('employee.import.upload');
                this.bsLoadingOverlayService.stop({ referenceId: 'emplist_loader' });
                this.toaster.pop('success', 'upload complete', '');
                this.responseData = response.data;
                this.employees = response.data.rows;

                this.columns_req = [];
                this.columns = [{ 'id': '', 'val': 'Skip' },];
                let i = 1;      // Skip first column
                this.col_models = [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
                -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
                -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
                -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
                -1, -1, -1];
                for (let colIdx in response.data['cols']) {
                    let col = response.data['cols'][colIdx];
                    let col_def = {
                        'id': col['type'],
                        'show': col['show'],
                        'val': col['col_desc'],
                        'f_idx': col['file_col_index']
                    };
                 
                    this.columns_req.push(col_def);
                    this.columns.push(col_def);

                    if (col['show']) {
                        this.columns_select.push(col_def);
                    }

                    this.col_models[i] = response.data['cols'][colIdx]['file_col_index'];
                    i++;
                }

                this.checkEmailDuplicates();

                this.currentStep++;

            },
            (response) => {
                this.bsLoadingOverlayService.stop({ referenceId: 'emplist_loader' });
                this.emitEvent('employee.import.upload.error');

                if (response.status == 400) {
                    this.toaster.pop('error', 'Import Failed', response.data);
                } else {
                    this.toaster.pop('error', 'Error', response.data);
                }
            }
        );
    }

    private checkEmailDuplicates(): void {
        this.newEmailAddresses = {};
        for (let i = 0; i < this.employees.length; i++) {
            let empEmailAddress = this.employees[i].fields[2].output_value;
            if (empEmailAddress !== undefined) {
                if (empEmailAddress in this.newEmailAddresses) {
                    this.newEmailAddresses[empEmailAddress].push(i + 1);
                    // console.log(this.employees[i].fields[2]);
                } else {
                    this.newEmailAddresses[empEmailAddress] = [i + 1];

                }
            }
        }
    }

    public edit_modal(field, colType: string): void {
        let that = this;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster', function ($scope, $uibModalInstance, toaster) {
                $scope.confirmation = false;
                $scope.modalHeader = "Edit Field";
                $scope.confirmButton = 'Save';
                $scope.cancelButton = 'Cancel';
                $scope.new_value = field['output_value'];
                $scope.prev_value = field['output_value'];
                $scope.confirm = () => {
                    if ($scope.new_value === undefined) {
                        $scope.new_value = '';
                    }
                    $scope.confirmation = true;
                    field['output_value'] = $scope.new_value;
                    $uibModalInstance.close($scope.confirmation);
                    if (colType === 'email') {
                        // console.log('editCell');
                        that.checkEmailDuplicates();
                    }

                }
                $scope.cancel = () => {
                    $scope.confirmation = false
                    $uibModalInstance.close($scope.confirmation)
                }
            }],
            templateUrl: '/static/templates/modals/edit_import_cell.html?202105090600'
        })

        modalInstance.result.then((result) => {
            if (result) {
            } else {
                this.toaster.pop('warning', 'Cancelled', 'No changes were made.');
            }
        })
    }

    // select/deselect all invite boxes for each employee if the checkbox changes
    public invite_all(): any {
        this.massInvite = !this.massInvite;

        if (this.massInvite === true) {
            for (var i: number = 0; i < this.employees.length; i++) {
                if (this.employees[i].import === true) {
                    this.employees[i].invite = true;
                }
            }
        } else if (this.massInvite === false) {
            for (var x: number = 0; x < this.employees.length; x++) {
                this.employees[x].invite = false;
            }
        }
    }
    // reset the mass invite checkbox if a user unselects an invite field
    public reset_invite(employee: any): any {
        if (employee.invite === false && this.massInvite === true) {
            this.massInvite = false;
        }
    }
    // select/deselect invite when checking the import checkbox
    public invite_select(employee: any): any {
        if (employee.import === false) {
            employee.invite = false;
        } else if (employee.import === true) {
            employee.invite = true;
        }
    }

    public emitEvent(eventName: string, eventAddData?: string): void {
        this.$scope.$emit('$EL', eventName, eventAddData);
    }


}

angular.module('beneple.employees')
    .controller('EmployeeImportController', EmployeeImportController);



// WEBPACK FOOTER //
// ./frontend/scripts/employee/controllers/employee-import.controller.ts